<template>
    <div>
        <h1 class="page-header"><i class="fa fa-globe"></i> Virtuális API <small></small></h1>
        <hr>
        <panel title="Felhasználók">
            <Loading v-if="!users"></Loading>
            <div v-else>
                <div class="row">
                    <div class="col-2">
                        <input class="form-control" v-model="keyword" placeholder="Keresés">
                    </div>
                    <div class="col-9 offset-1">
                        <form @submit.prevent="createUser(user)">
                            <div class="row mb-4 align-items-center">
                                <div class="col-3 text-end d-flex align-items-center justify-content-end">
                                    <span class="align-middle">Új létrehozása</span>
                                </div>
                                <div class="col-4">
                                    <input class="form-control" v-model="user.id" placeholder="Azonosító">
                                </div>
                                <div class="col-4">
                                    <input class="form-control" v-model="user.name" placeholder="Név">
                                </div>
                                <div class="col-1">
                                    <button class="btn btn-success">
                                        <i class="fa fa-save"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-4 mb-2 highlighted" v-for="(user, id) in filtered_users" :key="id">
                                <a @click.prevent="deleteUser(user.id)" class="text-danger"><i class="fa fa-trash"></i></a> [{{ user.id }}] {{ user.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </panel>
    </div>
</template>

<script>
import VirtualAPI from '../../apis/VirtualAPI';
import Confirmation from '../../apis/Confirmation';
export default {
    name: 'VirtualAPI',
    data() {
        return {
            user: { id: null, name: null },
            users: null,
            keyword: null
        }
    },
    computed: {
        filtered_users(){
            if (this.keyword !== null) {
                return this.users.filter(item =>
                    item.name.toLowerCase().includes(this.keyword.toLowerCase()) ||
                    item.id.toString().includes(this.keyword)
                );
            }
            else return this.users;
        }
    },
    created() {
        VirtualAPI.index()
            .then(response => {
                this.users = response.data;
            }).catch(() => {
                this.users = []
            })
    },
    methods: {
        createUser(user) {
            VirtualAPI.store(user)
                .then(() => {
                    Confirmation.swalSuccessMessage('Sikeres létrehozás');
                    this.users.unshift(user);
                    this.user = { id: null, name: null };
                })
        },
        deleteUser(id)
        {
            VirtualAPI.delete(id).then(()=>{
                this.users = this.users.filter(item => item.id !== id);
            });
        }
    }
};
</script>
<style>
.highlighted a{cursor:pointer;}
.highlighted:hover{background:#ececec;}
</style>